export const directionClasses = (language?: string) => {
  const rtl = language === 'ar'
  return {
    start: rtl ? 'text-end' : 'text-start',
    end: rtl ? 'text-start' : 'text-end',
    padStart: rtl ? 'pe-4' : 'ps-4',
    padEnd: rtl ? 'ps-4' : 'pe-4',
    roundStart: rtl ? 'rounded-end' : 'rounded-start',
    roundEnd: rtl ? 'rounded-start' : 'rounded-end',
    marginStart: rtl ? 'me-2' : 'ms-2',
    marginEnd: rtl ? 'ms-2' : 'me-2',
  }
}
